export function calSize(fileSize){
      return fileSize==null?"无":fileSize<1024?fileSize+"B":
      fileSize<1024*1024? Math.ceil(fileSize/1024)+"K":fileSize<1024*1024*1024?
      Math.ceil(fileSize/1024/1024)+"M":Math.ceil(fileSize/1024/1024/1024)+"G"
    }

/**
 * Parse the time to string
 * @param {new Date 对象} date
 * @param {string} 输出规则 Format
 * @returns {string | null}
 */
export function parseTime(date,Format){
    let o = {
      "M+": date.getMonth() + 1,                    // getMonth方法，月份从0开始的
      "d+": date.getDate(),                         // 获得天数
      "H+": date.getHours(),                        // 获得小时，24制
      "h+": date.getHours() > 12 ? date.getHours() - 12 : date.getHours(),  // 获得小时，12制
      "m+": date.getMinutes(),                      // 获得分钟
      "s+": date.getSeconds(),                      // 获得秒数，3位数
      "q+": Math.floor((date.getMonth() + 3) / 3),  // 获得季度
      "f+": date.getMilliseconds(),                 // 获得毫秒
    };
    
    if(/(y+)/.test(Format)) {						// 获得年份
      Format = Format.replace(RegExp.$1, date.getFullYear() + "").substr(4 - RegExp.$1.length);
      // RegExp.$1是yyyy（或者yy）的字符串
      // substr方法目的为：当年份是yy时截取从2开始到最后面的字符串，这样年份就变成了2位
      // 				   当年份是yyyy时截取从0开始到最后面的字符串，这样年份就变成了4位
    }
    
    for(let k in o) {								// 获得其他的信息
      if(new RegExp(`(${k})`).test(Format)) {		// 使用字符串模板在字符串里面解析变量
        Format = Format.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        // (("00" + o[k]).substr(("" + o[k]).length)))的目的为给天数、小时、分钟、秒数、季度的添0，毫秒无法添0
      }
    }
    return Format;
}